<template>
  <div id="home">
  </div>
</template>

<script>

export default {
  name: 'Home',
  components: {},
  metaInfo() {
    const { $i18n } = this;
    const title = $i18n.t('DASHBOARD');

    return {
      title,
      meta: []
    };
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/colors";

</style>
